import {
    FETCH_USER_CONSENTS,
    FETCH_USER_CONSENTS_SUCCESS,
    FETCH_USER_CONSENTS_FAILED
  } from "../store/types";
  import { firebase } from '../config/configureFirebase';
  import { onValue, get, off } from "firebase/database";
  
  export const fetchUserConsents = (userId) => (dispatch) => {
  const consentsRef = firebase.consentRef(userId);
  
    dispatch({
      type: FETCH_USER_CONSENTS,
      payload: null
    });
  
    onValue(consentsRef, async snapshot => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const userConsents = data[userId];
        
        if (userConsents) {
          // Yeni yapı: doğrudan kullanıcı ID'si altında veri var
          const consentData = {
            id: userId,
            ...userConsents
          };
          
          dispatch({
            type: FETCH_USER_CONSENTS_SUCCESS,
            payload: [consentData]
          });
        } else {
          dispatch({
            type: FETCH_USER_CONSENTS_SUCCESS,
            payload: []
          });
        }
      } else {
        dispatch({
          type: FETCH_USER_CONSENTS_SUCCESS,
          payload: []
        });
      }
    }, { onlyOnce: true });
  };
  
  export const fetchUserConsentsOnce = (userId) => (dispatch) => {
  const consentsRef = firebase.consentRef(userId);
  
    dispatch({
      type: FETCH_USER_CONSENTS,
      payload: null
    });
  
    get(consentsRef).then(snapshot => {
      if (snapshot.val()) {
        const userConsents = snapshot.val();
        
        // Doğrudan kullanıcı ID'si altındaki veri
        const consentData = {
          id: userId,
          sms: userConsents.sms || false,
          email: userConsents.email || false,
          call: userConsents.call || false,
          push: userConsents.push || false,
          createdAt: userConsents.createdAt || null,
          updatedAt: userConsents.updatedAt || null
        };
        
        dispatch({
          type: FETCH_USER_CONSENTS_SUCCESS,
          payload: [consentData]
        });
      } else {
        // Kullanıcı için consent verisi yok
        dispatch({
          type: FETCH_USER_CONSENTS_SUCCESS,
          payload: []
        });
      }
    }).catch(error => {
      console.error('Error fetching user consents:', error);
      dispatch({
        type: FETCH_USER_CONSENTS_FAILED,
        payload: error.message
      });
    });
  };
  